export default __webpack_public_path__ + "static/media/ic_stats_big.4a4ebfb7.svg";